import { AdId, useGridBlock } from '../../contexts'
import { useGridStore } from '../../store/gridStore'
import ComponentTitle from '../ComponentTitle/ComponentTitle'
import { Post } from '../Post/Post'
import { ILayout3, ILayout7, IPost } from '../../types'
import { useEffect, useMemo } from 'react'
import {
  Banner,
  Container,
  CustomIframe,
  PostsContainer,
} from './LayoutWithBanner.style'
import { Ad } from '../../sharedComponents'

type Props = {
  layout: ILayout7 | ILayout3
  index: number
  postsInBlock: 3 | 7
}
const LayoutWithBanner = ({ layout, index, postsInBlock }: Props) => {
  const { grid_title, layout_mobile, isIframe, iframeUrl } = layout

  const { gridId } = useGridBlock()
  // Replace the old destructuring with these:
  const pushAdUnit = useGridStore(state => state.pushAdUnit)
  const adUnitArray = useGridStore(state => state.adUnitArray)

  const { posts1, posts2 } = useMemo(() => {
    let posts1: IPost[] | null = null,
      posts2: IPost[] | null = null
    const posts = layout.posts.filter(post => post.image != '')
    posts1 = posts.slice(0, 3)
    if (postsInBlock === 7) {
      posts2 = posts.slice(3)
    }
    return { posts1, posts2 }
  }, [layout.posts, postsInBlock])

  useEffect(() => {
    if (!isIframe) {
      pushAdUnit({ id: index, adUnit: layout.adUnit })
    }
  }, [index, isIframe, layout.adUnit, pushAdUnit])

  // 2. Derive the adUnit directly during the render phase.
  // This replaces the useState and the second useEffect.
  const adUnit = useMemo(() => {
    if (adUnitArray.length === 0) {
      return null
    }

    let found = 1
    for (let i = 0; i < adUnitArray.length; i++) {
      // Check if this adUnit type already exists in the array
      if (adUnitArray[i].adUnit === layout.adUnit) {
        // If we found our own entry, stop counting
        if (adUnitArray[i].id === index) {
          break
        }
        found++
      }
    }
    return `${layout.adUnit}_${found}`
  }, [adUnitArray, index, layout.adUnit])

  // useEffect(() => {
  //   if (containerRef.current) {
  //     // const item = containerRef.current.querySelector('')
  //   }
  // }, [])

  const AdElement = useMemo(() => {
    return isIframe ? (
      <CustomIframe src={iframeUrl} />
    ) : (
      <Banner key={gridId} className={layout.adUnit}>
        {adUnit && <Ad id={adUnit as AdId} />}
      </Banner>
    )
  }, [adUnit, gridId, iframeUrl, isIframe, layout.adUnit])

  return posts1.length > 0 ? (
    <Container className={`${postsInBlock}-with-banner`}>
      <ComponentTitle componentTitle={grid_title} />
      <PostsContainer>
        {posts1.map(post => (
          <Post
            key={post.id}
            post={post}
            layoutMobile={layout_mobile}
            height='263px'
            hideSecondaryTitle
          />
        ))}
        {AdElement}
        {posts2?.map(post => (
          <Post
            key={post.id}
            post={post}
            layoutMobile={layout_mobile}
            hideSecondaryTitle
          />
        ))}
      </PostsContainer>
    </Container>
  ) : null
}
export default LayoutWithBanner
